import React from "react";
import MainImage from "../../../assets/Blogs/Blog1.jpg";
import Footer from "../../../components/Footer";
// import Navbar from "../../../components/Navbar";
import About from "../../../components/About";
import NavLite from "../../../components/NavLite";

function BlogAuthorityLaunchpad() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F7F3F2]">
      <title>Build a Strong Online Presence with The Authority Launchpad</title>
      <meta
        name="description"
        content="Discover how women entrepreneurs can build a powerful online presence with our Authority Launchpad package—featuring custom web design, SEO, and more."
      />
      <meta
        name="keywords"
        content="web design for women entrepreneurs, women owned business website design, female entrepreneur web design services, website design for women creatives, build online presence for women business, SEO for women business coaches, Austin web design for women entrepreneurs, web design for women entrepreneurs, women owned business website design, female entrepreneur web design services, website design for women creatives, build online presence for women business, website design for her, women business website, web design women, female website design, women web design, eCommerce website for women owned business, custom web design for female founders, website redesign for women professionals, SEO for women business coaches, brand strategy and web design for women, Austin web design for women entrepreneurs, high-converting websites for women business owners, premium website design for women-led brands, SEO optimized web design for women in business, website support and design for women professionals, local web designer for women owned businesses Austin, affordable website development for women entrepreneurs Austin, professional branding and website design for women Austin, mobile-friendly website design for women business owners Austin, website maintenance packages for women in business Austin"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-center"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
    
          <NavLite/>
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 font-semibold text-center bg-[#CFF098]">
                Your Digital Launchpad Starts Here
              </h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2] py-16 md:py-24">
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10">
            <div className="flex flex-col items-center text-center mb-16">
              <h2 className="text-3xl font-semibold md:text-4xl text-neutral-800 max-w-4xl uppercase tracking-wide">
                Introducing The Authority Launchpad
              </h2>
              <div className="w-16 h-1 bg-[#CFF098] mt-4 rounded-full"></div>
              <p className="mt-6 max-w-3xl text-lg text-neutral-700 font-light leading-relaxed">
                The Authority Launchpad is a foundational web design and SEO package built for women entrepreneurs who are ready to level up their online presence with purpose and professionalism.
              </p>
            </div>

            <div className="flex flex-col gap-8 mb-12">
              <div>
                <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                  Elite Website Design Tailored for You
                </h3>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Your website is more than a digital brochure—it's the face of your brand. With a professionally designed, mobile-friendly layout (including homepage, services, about, testimonials, and contact pages), your business will exude credibility and class. Perfect for women-led service providers and creatives ready to showcase their expertise.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                  Foundational SEO to Get You Found
                </h3>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  We help women-owned businesses rank for keywords that matter—like <em>website design for women creatives</em> or <em>SEO for women business coaches</em>. Our SEO setup includes initial keyword research, meta descriptions, and title tags to boost your visibility from the start.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                  Mobile-Responsive, Always
                </h3>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Whether viewed on a phone, tablet, or desktop, your site will function flawlessly. Because your audience is on the go—and your brand should be, too.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                  Content That Connects
                </h3>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  We support you in crafting compelling copy and integrating high-quality content that speaks directly to your ideal client. Whether you're a coach, consultant, or creative, your voice will come through clearly and confidently.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                  Beautiful Imagery and Simple Analytics
                </h3>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Enhance your visual storytelling with a curated library of professional stock images. Plus, monitor how your website is performing with a basic Google Analytics integration—so you can make informed decisions as you grow.
                </p>
              </div>

              <div className="mt-16 text-center">
                <h2 className="text-2xl font-semibold text-neutral-800 mb-6 uppercase tracking-wide">
                  Designed for Women, Built to Convert
                </h2>
                <p className="text-lg text-neutral-700 leading-relaxed mb-8">
                  Whether you're in Austin or anywhere in the world, <a href="https://hergrowthco.com/authoritylaunchpad"><strong>The Authority Launchpad</strong> </a>is your first step toward a standout digital presence. Ready to grow your brand with confidence?
                </p>
                <a href="/services" className="inline-block bg-[#CFF098] text-black py-3 px-6 text-sm rounded-full transition duration-300 focus:outline-none focus:ring-2 focus:ring-[#CFF098] focus:ring-offset-1">
                  Explore the Authority Launchpad
                </a>
              </div>
            </div>
          </div>
        </section>

        <div className="bg-[#2E2D2B]">
          <About />
        </div>
        <Footer />
      </section>
    </main>
  );
}

export default BlogAuthorityLaunchpad;
